<template>
  <div class="certificate">
    <div class="header">
      <div class="logo">
        <a href="//www.g12e.org"></a>
      </div>
      <div class="title">
        <p>中小学教育创新活动—教师微课展示</p>
      </div>
      <div class="userinfo">
        <a href="//www.g12e.org">首页</a>
        <i v-if="username"></i>
        <p v-if="username">
          欢迎您，<span :title="username">{{ username }}</span>
        </p>
      </div>
    </div>
    <div class="main">
      <div class="info__wrap--input" v-if="showType === 'input'">
        <div class="info__form">
          <el-form
            :label-position="labelPosition"
            label-width="80px"
            :model="checkInfo"
            ref="certificateRef"
          >
            <el-form-item label="名称">
              <el-input
                v-model="checkInfo.username"
                placeholder="请输入姓名"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input
                v-model="checkInfo.mobile"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
          </el-form>
          <p class="error__msg">{{ errorMsg }}</p>
          <button class="submit__btn" @click="submitCertificateInfo">
            点击查询
          </button>
        </div>
      </div>
      <div class="info__wrap--result" v-if="showType === 'result'">
        <div class="certificate-img_wrap">
          <div class="certificate-img">
            <img :src="certificateInfo.certificate_url" alt="图片加载失败" />
          </div>
          <div class="certificate-thumbnail">
            <div
              class="certificate-thumbnail-item"
              v-for="(certificateItem, index) in certificatesInfo"
              :key="index"
              @click="switchCertificate(index)"
            >
              <img
                class="certificate-thumbnail-item_img"
                :src="certificateItem.certificate_url"
              />
              <div v-if="!certificateItem.isShow" class="not-curt"></div>
            </div>
          </div>
        </div>

        <div class="certificate-info">
          <p class="certificate-info__tip">
            恭喜{{
              certificateInfo.name
            }}老师获得中小学教育创新活动——教师微课展示
          </p>
          <p class="certificate-info__cont">
            {{ certificateInfo.certificate }}
          </p>

          <!--  -->

          <button class="download__btn" @click="downloadCertificate">
            点击下载
          </button>
          <button class="search__again" @click="searchAgain">返回</button>
        </div>
      </div>

      <div class="info__wrap--noresult" v-if="showType === 'noresult'">
        <div class="tip-icon"></div>
        <p class="tip-text">
          {{ checkInfo.username }}老师，没有查询到您的证书哟! 再接再厉
        </p>
        <button @click="searchAgain">重新查询</button>
      </div>
    </div>
    <div class="common_footer">
      <common-footer></common-footer>
    </div>
  </div>
</template>

<script>
import commonFooter from '@/components/Layout/commonFooter'
import { getUserNameApi } from '@/api/plantform/common';
import { getUserCertificateApi, downloadUserCertificateApi } from '@/api/certificate';
import { $Cookies } from "@/utils";
export default {
  name: 'Certificate',
  components: {
    commonFooter,
  },
  data() {
    return {
      username: '',
      labelPosition: 'right',
      formLabelAlign: {
        name: '',
        region: '',
        type: ''
      },
      errorMsg: '',
      checkInfo: {
        username: '',
        mobile: ''
      },
      showType: 'input',
      certificateInfo: {
        certificate_url: 'https://img.cdeledu.com/g12eOrg/2022/0615/805b651cbb2db0b8-0.jpg',
        name: '111',
        certificate: '金典奖',
      },
      certificatesInfo: [],
    }
  },
  created() {
    const uid = $Cookies.get('uid')
    if (uid) {
      getUserNameApi({ uid }).then(data => {
        const { success } = data
        if (success) {
          this.username = data.result.realName
        }
      })
    }
  },
  methods: {
    submitCertificateInfo() {
      this.$refs.certificateRef.validate(valid => {
        if (valid) {
          if (!this.checkInfo.username) {
            this.errorMsg = '用户姓名不能为空'
            return
          }
          if (!this.checkInfo.mobile) {
            this.errorMsg = '手机号不能为空'
            return
          } else {
            if (!/^1(3|4|5|6|7|8|9)[0-9]\d{8}$/.test(this.checkInfo.mobile)) {
              this.errorMsg = '手机号格式错误'
              return
            }
          }
          this.errorMsg = ''
          this._getUserCertificateApi()
        }
      })
    },

    searchAgain() {
      this.showType = 'input'
    },

    switchCertificate(index) {
      let certificatesInfo = this.certificatesInfo.concat()
      certificatesInfo = certificatesInfo.map(item => {
        return {
          ...item,
          isShow: false,
        }
      })
      certificatesInfo[index].isShow = true
      this.certificateInfo = certificatesInfo[index]
      this.certificatesInfo = certificatesInfo
    },

    _getUserCertificateApi() {
      getUserCertificateApi({
        mobile: this.checkInfo.mobile,
        name: this.checkInfo.username,
        userNo: $Cookies.get('uid') || 0
      }).then(res => {
        if (res.success) {
          this.certificatesInfo = res.result.map(item => {
            return {
              ...item,
              isShow: false
            }
          })
          // this.certificatesInfo[0].isShow = true
          this.switchCertificate(0)
          this.showType = 'result'
        } else {
          if (res.errorCode === '-19') {
            this.showType = 'noresult'
          } else {
            this.$message.error('查询失败，请稍后重试')
          }
        }
      })
    },

    downloadCertificate() {

      const imgUrl = this.certificateInfo.certificate_url

      if (!imgUrl) {
        this.$message.error('图片加载失败，请刷新页面后重新下载')
        return
      }
      downloadUserCertificateApi({
        userNo: $Cookies.get('uid') || 0,
        certificate_url: this.certificateInfo.certificate_url
      }).then(res => {
        const u8Arr = new Uint8Array(res)
        const bold = new Blob([u8Arr], { type: 'image/png' })
        const aLink = document.createElement('a')
        var evt = document.createEvent('HTMLEvents')
        evt.initEvent('click', true, true)
        aLink.download = this.certificateInfo.name + '-' + this.certificateInfo.certificate
        aLink.href = URL.createObjectURL(bold)
        aLink.click()
      })
    },
  }
}
</script>

<style lang="scss">
.certificate {
  background: center top url("~@/assets/images/certificate/bg-body.png")
    no-repeat;
  .header {
    width: 1200px;
    height: 140px;
    margin: 0 auto;
    .logo {
      width: 207px;
      height: 40px;
      float: left;
      margin-top: 50px;
      a {
        display: block;
        width: 100%;
        height: 100%;
        background: 100% 100% url("~@/assets/images/certificate/logo.png")
          no-repeat;
      }
    }
    .title {
      float: left;
      height: 40px;
      line-height: 40px;
      margin: 50px;
      font-size: 38px;
      color: #fff;
      letter-spacing: 5px;
    }
    .userinfo {
      float: left;
      height: 40px;
      line-height: 40px;
      margin-top: 50px;
      font-size: 16px;
      i {
        float: left;
        width: 2px;
        height: 16px;
        background: #fff;
        margin: 11px 15px;
      }
      a,
      p {
        float: left;
        height: 100%;
        color: #fff;
        max-width: 140px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .main {
    width: 1200px;
    height: 690px;
    border-radius: 10px;
    background: #fff;
    margin: 0 auto 100px;
    .info__wrap--input {
      width: 100%;
      height: 100%;
      background: 100% 100% url("~@/assets/images/certificate/bg-01.png")
        no-repeat #e9f7ff;
      box-sizing: border-box;
      padding-top: 180px;
      .info__form {
        width: 513px;
        height: 309px;
        margin: 0 auto;
        background: 100% 100% url("~@/assets/images/certificate/bg-login.png")
          no-repeat;
        box-sizing: border-box;
        padding: 60px 80px;
        .error__msg {
          color: #ff0000;
          text-align: center;
          font-size: 14px;
        }

        .submit__btn {
          margin-top: 10px;
          display: block;
          width: 200px;
          height: 50px;
          border-radius: 25px;
          background: linear-gradient(0deg, #ff8a18, #ffbf64);
          box-shadow: 0px 6px 10px 0px rgba(255, 138, 0, 0.23);
          font-size: 20px;
          color: #fff;
          margin: 10px auto;
          outline: none;
          border: 0;
          cursor: pointer;
        }

        .el-form-item__label {
          font-size: 16px;
          color: #666;
        }
        .el-input__inner {
          width: 252px;
          height: 40px;
          border: 1px solid #e7e7e7;
          border-radius: 20px;
          font-size: 16px;
          &:placeholder {
            color: #bbbbbb;
          }
        }
      }
    }
    .info__wrap--result {
      width: 100%;
      height: 100%;
      background: 100% 100% url("~@/assets/images/certificate/bg-02.png")
        no-repeat #e9f7ff;
      box-sizing: border-box;

      .certificate-img_wrap {
        width: 580px;
        height: 100%;
        float: left;
        .certificate-img {
          width: 340px;
          height: 474px;
          box-sizing: border-box;
          padding: 10px;
          background: #fff;
          border-radius: 10px;
          margin: 50px auto 30px;
          box-shadow: 0px 0px 20px 0px rgba(175, 206, 222, 0.21);
          img {
            width: 320px;
            height: 454px;
          }
        }
        .certificate-thumbnail {
          // background: red;
          height: 100px;
          margin: 0 50px;
          overflow-x: scroll;
          text-align: center;
          &::-webkit-scrollbar {
            display: none;
          }
          &-item {
            // float: left;
            display: inline-block;
            height: 100px;
            width: 70px;
            margin: 0 10px;
            position: relative;
            cursor: pointer;
            &_img {
              width: 100%;
              height: 100%;
            }
            .not-curt {
              position: absolute;
              transition: all .3s;
              left: 0;
              top: 0;
              bottom: 0;
              right: 0;
              content: "";
              background: rgba(0, 0, 0, .4);
            }
          }
        }
      }

      .certificate-info {
        width: 540px;
        height: 100%;
        float: left;
        &__tip {
          margin-top: 230px;
          font-size: 20px;
          font-weight: bold;
          text-align: center;
          line-height: 1;
        }

        &__cont {
          text-align: center;
          font-size: 36px;
          line-height: 1;
          color: #ff5a00;
          font-weight: bold;
          margin-top: 50px;
        }

        .download__btn {
          display: block;
          margin: 60px auto 0;
          width: 220px;
          height: 60px;
          border-radius: 30px;
          color: #fff;
          font-size: 22px;
          text-align: center;
          line-height: 60px;
          background: linear-gradient(0deg, #ff8a18, #ffbf64);
          box-shadow: 0px 6px 10px 0px rgba(255, 138, 0, 0.23);
          border: 0;
          outline: none;
          cursor: pointer;
        }
        .search__again {
          background: transparent;
          display: block;
          margin: 20px auto 0;
          border: 0;
          outline: none;
          color: #bbbbbb;
          cursor: pointer;
          font-size: 16px;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
    .info__wrap--noresult {
      width: 100%;
      height: 100%;
      background: 100% 100% url("~@/assets/images/certificate/bg-03.png")
        no-repeat #e9f7ff;
      box-sizing: border-box;
      padding-top: 180px;
      .tip-icon {
        width: 89px;
        height: 118px;
        margin: 0 auto 36px;
        background: 100% 100% url("~@/assets/images/certificate/i-no-cer.png")
          no-repeat;
      }
      .tip-text {
        font-weight: bold;
        font-size: 20px;
        text-align: center;
      }
      button {
        display: block;
        margin: 60px auto 0;
        width: 220px;
        height: 60px;
        border-radius: 30px;
        color: #fff;
        font-size: 22px;
        text-align: center;
        line-height: 60px;
        background: linear-gradient(0deg, #ff8a18, #ffbf64);
        box-shadow: 0px 6px 10px 0px rgba(255, 138, 0, 0.23);
        cursor: pointer;
        border: 0;
        outline: none;
      }
    }
  }
}
</style>